import { Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class OneTrustService {
  private initialized = false;

  constructor(private windowRef: WindowRefService) { }

  initialize(): void {
    if (!this.initialized) {
      const local = ENVIRONMENT === 'local';
      const hostname = this.windowRef.host();
      interface LibraryId { [key:string]: string | undefined }
      const scriptIds: LibraryId = {
        'iii-conv.com': '874e9a0f-db78-4555-aa29-3e65d7aca240',
        'iii-lab.eu': '0190e595-62a5-725e-b445-29755aeac229',
        'stellanj.org': '0190bb99-d488-7a13-ad4b-6460e2e4a1f7',
        'bccls.org': '0190bc1e-86cd-74e9-b326-2bc8adf41ba8',
        'aucklandlibraries.govt.nz': '0190d9d5-b6d3-7f3b-902a-cb3046e81552',
        'midhudsonlibraries.org': '0190df79-eaa1-7823-86d4-317d3d2d28c9',
        'phoenixpubliclibrary.org':'0190e09a-ed89-7d27-8ab0-4a70d8d2ce40',
        'rhpl.org': '0190e5d1-87cc-7140-89fe-34888afed942',
        'acpl.lib.in.us': '0190ebb0-86b5-7728-afd9-bf4477264a6d',
        'cmpl.org': '0190ebb5-823c-789e-830c-a31b1cd48858',
        'nlb.gov.sg': '0190ebb4-681f-740c-a5c2-eea07f23221e',
        'nypl.org': '0190ebc0-fabf-7cf5-9e38-62df069bdd13',
        'watsonvillelibrary.gov': '0190ebc2-b7bc-7a7c-a84e-128aeffb5c60',
        'monarchcatalog.org':'01916b62-16d4-7e7b-84f8-27a846434ce0',
        'nvdpl.ca':'0191e2be-0cef-7364-84c3-f8c95d17a42b',
        'auroralibrary.org':'0191e2c7-80aa-71fc-b140-0ad8db6b85f6',
        'nassaulibraries.org':'0191e2c8-968d-7a9b-a44a-a37954623fc1',
        'cmcl.org':'01924dd6-6aaa-7f49-94a0-ec19daf22507',
        'oldhampl.org':'01924dd7-d6a2-76a3-96dc-7bd3eaea50ff',
        'mcpl.info':'01928b68-ca33-7760-9d54-597a4006fcb8',
        'jaxpubliclibrary.org':'0193a1f4-c2af-7115-b148-589ca9bd5e09',
        'scpl.org':'0193b69c-445d-7623-86a6-5d7ec86cff07',
        'franklintwp.org':'01943c82-a7e0-7c54-94b4-df609d921e15',
        'lpl.ca':'01959597-f872-7af5-8eac-c31c8f249543',
        'schaumburglibrary.org':'0195b525-e881-7aa8-b146-fa5ffa328861',
        'dclibrary.org':'019625fd-84b5-7629-b519-cb686299cb1e',
        'mybcpl.org':'019625ff-a54d-7506-9345-4b6cf73021ed',
        'malmo.se':'01962609-25e3-7bd6-a9ad-ac59855674b7',
        'massillonlibrary.org': '01968241-6333-7ff6-8d5e-d9765ff76b7f',
        'aurorapubliclibrary.org':'0196cf16-2a39-752f-8e7c-72ee7a86c977',
        'sarasotacountylibraries.org':'0196e997-cae2-7528-a7f4-e80b635f1132',
        'mountainview.gov':'01971686-ca06-7cd9-9fe0-64ee1ee8cc9b',
        'orionlibrary.org':'01973c0e-ba57-7537-9383-675bf804ebbd',
        'lcplin.org':'01981970-cc76-76ba-8edd-3b7dee42d6eb',
        'tnrl.ca':'0198562d-d02a-7c12-8cd1-38933e5023f8',
        'tolibrary.org':'0198625e-ffbf-74bf-ad3a-bb8c84e60e6a',
        'keyslibraries.org':'0198a431-30f6-7dd3-836d-b3d2bac7fe41',
        'bridgeslibrarysystem.org':'0198a433-120f-7871-855c-450f8291047f',
        'southfieldlibrary.org':'01993946-658c-728e-bcb6-a64f52d87fcf',
        'virl.bc.ca':'01992f7d-fddf-7672-8c55-1baa673173be',
        'tracpac.ab.ca':'01994cd8-27bf-788e-8b4d-9447d13e1abc',
        'sals.edu':'0199c53f-9b3d-7fb8-9677-484576a1d996',
        'alpl.org':'019a5087-d18f-7bde-a055-d8e43f0d2ddd',
        'lakeblufflibrary.org':'019a7972-acc3-74aa-8839-0a6298056e19',
        'default': '08f85ea6-474c-4120-8168-4a69704cb987'
      };
      let idScript = '874e9a0f-db78-4555-aa29-3e65d7aca240-test';
      if (!local) {
        const matchedHost = Object.keys(scriptIds).find(key => hostname.includes(key));
        idScript = scriptIds[matchedHost] || scriptIds['default'];
      }
      const sdkScript = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      this.appendScript(sdkScript, idScript);
      this.appendInlineScript('function OptanonWrapper() { }');
      this.appendOverlayHandlingScript();
      this.initialized = true;
    }
  }

  private appendScript(src: string, id: string = ''): void {
    const script = this.windowRef.nativeWindow().document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    if (id?.length) {
      script.setAttribute('data-domain-script', id);
    }
    this.windowRef.nativeWindow().document.head.insertBefore(script, this.windowRef.nativeWindow().document.head.firstChild);
  }

  private appendInlineScript(text: string): void {
    const optanonScript = this.windowRef.nativeWindow().document.createElement('script');
    optanonScript.type = 'text/javascript';
    optanonScript.text = text;
    this.windowRef.nativeWindow().document.head.insertBefore(optanonScript, this.windowRef.nativeWindow().document.head.firstChild);
  }

  private appendOverlayHandlingScript(): void {
    const scriptContent = `
      document.addEventListener("click", function(evt) {
        if (evt.target.id === 'close-pc-btn-handler') {
          document.querySelector('.onetrust-pc-dark-filter').style.display = 'none';
        }
      });
    `;
    this.appendInlineScript(scriptContent);
  }
}
